export default "__VITE_ASSET__Dl64DHEl__"